import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "@/api/index";
import util from "@/util";
import localStore from './localStore';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: '',
    token: localStore.getItem('token') || '',
    user: {},
    expiresAt: 0 // set auth expired to 5 seconds ago
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, {expiresIn, status, token, user}){
      state.status = status;
      state.token = token;
      state.user = user;
      state.expiresAt = util.expiresDate(expiresIn).getTime(); 
      state.expires = new Date(state.expiresAt).toString();
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.expiresAt = new Date().getTime() - 5000; // set auth expired to 5 seconds ago
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        ApiService.apiCore.post('/auth/login',user)
          .then(resp => {
            const token = resp.data.token;
            const expiresIn = resp.data.expiresIn;
            const user = resp.data.user;
            localStore.setItem('token', token)

            commit('auth_success', {...resp.data})
            resolve(resp)
          })
          .catch(err => {
            console.log(err)
            commit('auth_error')
            localStore.removeItem('token')
            reject(err)
          })
      })
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout')
        localStore.removeItem('token')
        //delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn3: state => {
      return !!state.token;
    },
    isLoggedIn: (state)  => {
      //state => !!state.token,
      let validAuthToken = false;
      if (state.token && state.expiresAt ) {
        let locTime = new Date().getTime(); // number of milliseconds since 1 January 1970 00:00:00 UTC. 
        validAuthToken = locTime < state.expiresAt;
      } 
      return validAuthToken;
     return !!state.token;
    },
    authStatus: state => state.status,
  }
})
